"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var provider;
        (function (provider) {
            var upgradeFromGF;
            (function (upgradeFromGF) {
                function init() {
                    $('#Proceed').hide();
                    addEvents();
                }
                upgradeFromGF.init = init;
                function addEvents() {
                    $('#Accept').change(function (event) {
                        if ($(this).is(':checked'))
                            $('#Proceed').show();
                        else
                            $('#Proceed').hide();
                    });
                    $('#UpgradeBtn').click(function (event) {
                        event.preventDefault();
                        const submitType = this.value;
                        appn.dialog.confirm({
                            modalColor: 'modal-info',
                            title: T('Upgrade Billing Plan'),
                            message: T('Are you sure you want to upgrade?'),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    $('form').append('<input type="hidden" name="submitType" value="' + submitType + '" />');
                                    $('form').submit();
                                }
                                else
                                    event.stopImmediatePropagation();
                            }
                        });
                    });
                }
            })(upgradeFromGF = provider.upgradeFromGF || (provider.upgradeFromGF = {}));
        })(provider = views.provider || (views.provider = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
